/** Join API origin and version prefix without duplicate slashes. */
export function joinApiBaseUrl(apiUrl: string, apiPrefix: string): string {
  const base = apiUrl.replace(/\/+$/, '');
  const prefix = apiPrefix.replace(/^\/+|\/+$/g, '');
  return prefix ? `${base}/${prefix}` : base;
}
